import React, { useState } from "react";
import { useApi } from "../../hooks/useApi";
import { useAuth } from "../../context/AuthContext";
import {
  Card,
  Spinner,
  ErrorBox,
  SimpleTable,
} from "../../components/ui/basics";
import CrudModal from "../../components/normative/CrudModal";
import { TIPO } from "../../constants/normativeTipo";

export default function ProfiliSection() {
  const { apiRequest } = useAuth();
  const { data: regioni } = useApi("/normative/regioni");
  const [regione, setRegione] = useState(null);
  const endpoint = regione
    ? `/normative/profili?regione=${encodeURIComponent(regione)}`
    : null;
  const { data: profili, loading, error, reload } = useApi(endpoint, [regione]);
  const [modal, setModal] = useState(null);

  const fields = [
    {
      key: "codice",
      label: "Codice",
      required: true,
      disabled: modal?.mode === "edit",
    },
    { key: "name", label: "Nome", required: true },
    { key: "ordine", label: "Ordine", type: "number" },
    { key: "descrizione", label: "Descrizione (gravità/criteri)" },
  ];

  const submit = async (values) => {
    const payload = {
      ...values,
      tipo: TIPO.PROFILO,
      parentcodice: regione,
      ordine: values.ordine ? Number(values.ordine) : null,
    };
    if (modal.mode === "create") {
      await apiRequest("/normative/anagrafiche", {
        method: "POST",
        body: JSON.stringify(payload),
      });
    } else {
      await apiRequest(`/normative/anagrafiche/${modal.record.id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });
    }
    reload();
  };

  const elimina = async (r) => {
    if (!window.confirm(`Eliminare il profilo "${r.name}"?`)) return;
    await apiRequest(`/normative/anagrafiche/${r.id}`, { method: "DELETE" });
    reload();
  };

  return (
    <Card
      title="Profili ospiti"
      subtitle="Livelli di gravità/assistenza per regione — determinano le righe della matrice requisiti"
      actions={
        regione && (
          <button
            onClick={() => setModal({ mode: "create" })}
            className="text-sm bg-primary-600 text-white px-3 py-1.5 rounded hover:bg-primary-700"
          >
            + Nuovo profilo
          </button>
        )
      }
    >
      <select
        value={regione || ""}
        onChange={(e) => setRegione(e.target.value || null)}
        className="border border-gray-300 rounded px-3 py-1.5 text-sm bg-white mb-3"
      >
        <option value="">— Seleziona regione —</option>
        {(regioni || []).map((r) => (
          <option key={r.codice} value={r.codice}>
            {r.name}
          </option>
        ))}
      </select>

      {!regione && (
        <p className="text-sm text-gray-400 py-8 text-center">
          Seleziona una regione per gestirne i profili ospiti.
        </p>
      )}
      {loading && <Spinner />}
      {error && <ErrorBox message={error} onRetry={reload} />}
      {regione && profili && (
        <SimpleTable
          rowKey={(r) => r.id}
          columns={[
            { key: "codice", label: "Codice" },
            { key: "name", label: "Nome" },
            { key: "ordine", label: "Ordine", align: "right" },
            { key: "descrizione", label: "Descrizione" },
            {
              key: "azioni",
              label: "",
              render: (r) => (
                <div className="flex gap-2 justify-end">
                  <button
                    onClick={() => setModal({ mode: "edit", record: r })}
                    className="text-xs text-primary-600 hover:underline"
                  >
                    Modifica
                  </button>
                  <button
                    onClick={() => elimina(r)}
                    className="text-xs text-red-600 hover:underline"
                  >
                    Elimina
                  </button>
                </div>
              ),
            },
          ]}
          rows={profili}
        />
      )}
      {modal && (
        <CrudModal
          title={
            modal.mode === "create"
              ? "Nuovo profilo"
              : `Modifica ${modal.record.name}`
          }
          fields={fields}
          initialValues={modal.record || {}}
          onSubmit={submit}
          onClose={() => setModal(null)}
        />
      )}
    </Card>
  );
}
